/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, OnInit, ViewChild } from '@angular/core';
import { PoNotificationService, PoModalAction, PoNotification, PoModalComponent } from '@po-ui/ng-components';
import { LiteralsService } from '../../services/literals-service';
import { LiteralsWords } from 'src/app/i18n/literals.model';

@Component({
  selector: 'tgv-notification-modal',
  standalone: false,
  templateUrl: './notification-modal.component.html'
})
export class NotificationModalComponent implements OnInit {
  @ViewChild(PoModalComponent, { static: true }) poModal: PoModalComponent;
  @ViewChild('detailsModal', { static: true }) detailsModal: PoModalComponent;
  title: string;
  content: string;
  poNotificationModel: PoNotification;
  modalOptions: PoModalAction[];
  detailsModalErrorMessage: string;
  literals: LiteralsWords;

  constructor(private literalsService: LiteralsService, private PoNotificationService: PoNotificationService) {
    this.literals = this.literalsService.getLiteralModule();
  }

  ngOnInit(): void {
    this.onInitPoNotification();
    this.onInitModalOptions();
  }

  onInitPoNotification(): void {
    this.poNotificationModel = {
      message: '',
      actionLabel: this.literals.str0061, // Detalhes
      action: () => this.detailsModal.open()
    };
  }

  onInitModalOptions(): void {
    this.modalOptions = [
      {
        action: () => this.poModal.close(),
        label: this.literals.str0123 //Confirmar
      },
      {
        action: () => this.poModal.close(),
        label: this.literals.str0251 //Cancelar
      }
    ];
  }

  close(): void {
    this.poModal.close();
  }

  openModal(title: string, content: string, label: string, button: number, action = null): void {
    this.title = title;
    this.content = content;
    this.modalOptions[button].label = label;
    this.modalOptions[button].action = action;
    this.poModal.open();
  }

  openNotificationMessage(isError = false, message = '', error = ''): void {
    if (!isError) {
      this.PoNotificationService.success(message);
    } else {
      this.poNotificationModel.message = message;
      this.PoNotificationService.error(this.poNotificationModel);
      this.detailsModalErrorMessage = error;
    }
  }
}
